import React, { useState, useEffect } from 'react';
import { getApi } from '../../../api/endpoints.js';
import uiManager from '../../../../config/ui.js';
import PAGES from '../../../data/PagesConstants.js';
import ListingComponent from '../../../components/ListingComponent.js';
import UiAction from "../../../components/UiAction.js";
import UI_ACTIONS from "../../../data/UiActionConstants.js";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEdit } from "@fortawesome/free-solid-svg-icons";
import { useNavigate, useParams } from "react-router-dom";

const Listing = (props) => {
  const [filtersModel, setFiltersModel] = useState({});
  const navigate = useNavigate();
  const params = useParams();

  const defaultHeaderConfig = { disableSort: true };
  const headers = [
    {
      ...defaultHeaderConfig,
      label: 'Date',
      attr: 'date',
    },
    {
      ...defaultHeaderConfig,
      label: 'Amount',
      attr: 'amount',
    },
    {
      ...defaultHeaderConfig,
      label: 'Swaps',
      attr: 'swaps',
    },
    {
      disableSort: true,
      label: 'Actions',
      value: (row) => {
        return <div style={{ display: 'flex', justifyContent: 'space-around' }}>
          <UiAction uiAction={uiManager.getUiAction(UI_ACTIONS.view_distributor_list.name)}>
            <div style={{ cursor: 'pointer' }}>
              <FontAwesomeIcon icon={ faEye } onClick={(e)=>{
                navigate(`/partner_billings/${params.id}/date/${row.date}`)}
              } />
            </div>
          </UiAction>
        </div>
      }
    }
  ]

  return <ListingComponent
    listingMutation={getApi('monthlyEarngingDetails')}
    params={{...props.listingParams, role:'cp'}}
    className="monthly-earnings_listing-page"
    contentHeading="Monthly Earnings - Results"
    headers={headers}
    recordsKey="daily_earnings"
    hideSearch={true}
  />
};

export default Listing;

